import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import PollOptions from './Poll/PollOptions';
import PollImage from './Poll/PollImage';
import PollState from '../states/PollState';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import PollControls from '../utils/PollControls';
import Dropdown from 'flarum/common/components/Dropdown';
import PollSubmitButton from './Poll/PollSubmitButton';
import { slug } from 'flarum/common/utils/string';
import classList from 'flarum/common/utils/classList';
import PollTitle from './Poll/PollTitle';
import PollSubtitle from './Poll/PollSubtitle';
import PollDraftBadges from './Poll/PollDraftBadges';
export default class PollView extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", void 0);
    /**
     * Alert before navigating away using browser's 'beforeunload' event
     */
    _defineProperty(this, "preventClose", e => {
      if (this.state.hasSelectedOptions()) {
        e.preventDefault();
        return true;
      }
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new PollState(this.attrs.poll);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.preventClose = this.preventClose.bind(this);
    window.addEventListener('beforeunload', this.preventClose);
  }
  onremove(vnode) {
    super.onremove(vnode);
    window.removeEventListener('beforeunload', this.preventClose);
  }
  view() {
    const poll = this.attrs.poll;
    const state = this.state;
    // @ts-expect-error
    const controls = PollControls.controls(poll, this);
    (poll.publicPoll() || poll.canEdit()) && controls.add('view', m(Button, {
      onclick: state.showVoters,
      icon: "fas fa-poll"
    }, app.translator.trans('fof-polls.forum.public_poll')));
    return m("div", {
      className: classList('Poll', poll.imageUrl() && 'Poll--image'),
      "data-id": poll.id()
    }, this.controlsView(controls.toArray()), m("div", {
      className: "Poll-wrapper"
    }, this.createMainView().toArray()));
  }
  createMainView() {
    const items = new ItemList();
    items.add('header', m("div", {
      className: "Poll-header"
    }, this.createPollHeader().toArray()));
    items.add('content', m("div", {
      className: "Poll-content"
    }, this.createPollContent().toArray()));
    items.add('footer', m("div", {
      className: "Poll-footer"
    }, this.createPollFooter().toArray()));
    return items;
  }
  createPollHeader() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    if (poll.isDraft()) items.add('draftBadges', m(PollDraftBadges, {
      poll: poll
    }), 20);
    items.add('title', m(PollTitle, {
      poll: poll
    }));
    if (poll.subtitle()) items.add('subtitle', m(PollSubtitle, {
      poll: poll
    }));
    return items;
  }
  createPollContent() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    if (poll.imageUrl()) {
      items.add('image', m(PollImage, {
        poll: poll
      }));
    }
    items.add('form', m("form", {
      className: "Poll-form"
    }, this.createFormItems().toArray()));
    return items;
  }
  createPollFooter() {
    const items = new ItemList();
    const state = this.state;
    const infoItems = this.infoItems(state.getMaxVotes());
    items.add('sticky', m("div", {
      className: "Poll-sticky"
    }, !infoItems.isEmpty() && m("div", {
      className: "helpText PollInfoText"
    }, infoItems.toArray()), state.showButton() && m(PollSubmitButton, {
      state: state
    })));
    return items;
  }
  createFormItems() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    const state = this.state;
    const questionSlug = slug(poll.question());
    items.add('elements', m("fieldset", null, m("legend", {
      className: "sr-only"
    }, poll.question()), m(PollOptions, {
      name: questionSlug,
      options: poll.options(),
      state: state
    })));
    return items;
  }
  controlsView(controls) {
    return !!controls.length && m(Dropdown, {
      icon: "fas fa-ellipsis-v",
      className: "PollListItem-controls",
      menuClassName: "Dropdown-menu--right",
      buttonClassName: "Button Button--icon Button--flat",
      accessibleToggleLabel: app.translator.trans('fof-polls.forum.poll_controls.toggle_dropdown_accessible_label')
    }, controls);
  }
  infoItems(maxVotes) {
    const items = new ItemList();
    const poll = this.attrs.poll;
    if (app.session.user && !poll.canVote() && !poll.hasEnded()) {
      items.add('no-permission', m("span", null, m("i", {
        className: "icon fas fa-times-circle fa-fw"
      }), app.translator.trans('fof-polls.forum.no_permission')));
    }
    if (poll.endDate()) {
      items.add('end-date', m("span", null, m("i", {
        class: "icon fas fa-clock fa-fw"
      }), poll.hasEnded() ? app.translator.trans('fof-polls.forum.poll_ended') : app.translator.trans('fof-polls.forum.days_remaining', {
        time: dayjs(poll.endDate()).fromNow()
      })));
    }
    if (poll.canVote() && !poll.hasEnded() && !this.state.hasVoted()) {
      items.add('max-votes', m("span", null, m("i", {
        className: "icon fas fa-poll fa-fw"
      }), app.translator.trans('fof-polls.forum.max_votes_allowed', {
        max: maxVotes
      })));
      if (!poll.canChangeVote()) {
        items.add('cannot-change-vote', m("span", null, m("i", {
          className: "icon fas fa-".concat(this.state.hasVoted() ? 'times' : 'exclamation', "-circle fa-fw")
        }), app.translator.trans('fof-polls.forum.poll.cannot_change_vote')));
      }
    }
    if (poll.hasEnded() || this.state.hasVoted()) {
      items.add('total-vote-count', m("span", null, m("i", {
        className: "icon fas fa-poll fa-fw",
        "aria-hidden": "true"
      }), app.translator.trans('fof-polls.forum.poll.total_votes', {
        count: poll.voteCount()
      })));
    }
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollView', PollView);